// src/axiosInstance.ts
import axios, { AxiosRequestConfig, Method } from "axios";
import store from "../stores";
import { setGlobalState } from "../stores/global.store";
import { message as $message } from "antd";
import { ApiResponse } from "../interface/question.interface";

// export const BASE_URL = "http://localhost:3343/api/v1";
export const BASE_URL = "https://be-cms.cdhomeland.vn/api/v1";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

const setLoading = (loading: boolean) => {
  store.dispatch(setGlobalState({ loading }));
};

// Interceptor request
axiosInstance.interceptors.request.use((config) => {
  setLoading(true);
  const token = localStorage.getItem("token")?.replace(/^"|"$/g, "");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});
// Interceptor response
axiosInstance.interceptors.response.use(
  (response) => {
    setLoading(false);
    return response;
  },
  (error) => {
    const message = error?.response?.data?.info?.message || "Lỗi hệ thống";
    setLoading(false);

    $message.error(message);
    return Promise.reject({
      status: false,
      message,
      result: null,
    });
  }
);

export default axiosInstance;

export const GET = async <T = any>(url: string, params?: any) => {
  const res = await axiosInstance.get<ApiResponse<T>>(url, { params });
  return res.data.data;
};

export const POST = async <T = any>(url: string, data: any) => {
  const res = await axiosInstance.post<ApiResponse<T>>(url, data);
  return res.data;
};

export const PUT = async <T = any>(url: string, data: any) => {
  const res = await axiosInstance.put<ApiResponse<T>>(url, data);
  return res.data;
};

export const DEL = async <T = any>(url: string, data?: any) => {
  const res = await axiosInstance.delete<ApiResponse<T>>(url, { data });
  return res.data;
};

export const IMPORT = async <T = any>(
  url: string,
  file: File
): Promise<ApiResponse<T>> => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await axiosInstance.post<ApiResponse<T>>(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};

export const addFormDataMultipart = async (url: string, data: FormData) => {
  const res = await axiosInstance.post<ApiResponse<any>>(url, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const addFormData = POST;
export const editFormRequest = PUT;
export const deleteFormRequest = DEL;
